
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $591199213254ef58$exports = {};
$591199213254ef58$exports = JSON.parse('[{"name":"\uAC00\uC744\uD559\uAE30 \uC815\uADDC\uBC18","href":"/courses/fall"},{"name":"\uC5EC\uB984\uBC29\uD559 \uD2B9\uAC15","href":"/courses/summer","hide":true},{"name":"2026 \uC5EC\uB984/\uAC00\uC744 \uB300\uD68C \uD2B8\uB799","href":"/courses/competitions-2026"},{"name":"\uACA8\uC6B8\uBC29\uD559 \uD2B9\uAC15","href":"/courses/winterbreak","hide":true},{"name":"\uAC00\uC744\uD559\uAE30 \uC815\uADDC\uBC18","href":"/courses/fall","hide":true},{"name":"\uCD08\uB4F1\uBD80 \uB300\uD68C","href":"/courses/competitions-jr"},{"name":"\uC911\xb7\uACE0\uB4F1\uBD80 \uB300\uD68C","href":"/courses/competitions-sr"}]');


const $bac26ecb701a9cac$var$$courseSubMenu = document.getElementById('courses-sub-menu');
const $bac26ecb701a9cac$var$courseSubMenuHtml = `
  <ul class="mx-auto mt-auto flex h-full max-w-7xl gap-6 overflow-x-auto px-4 text-sm sm:text-base lg:px-12">
    ${(0, (/*@__PURE__*/$parcel$interopDefault($591199213254ef58$exports))).filter((i)=>!i.hide).map((item)=>`
        <a
          href="${item.href}"
          class="cursor-pointer border-b-2 px-2 py-3 sm:py-4 font-normal text-nowrap transition ${window.location.pathname === item.href ? 'border-flamingo-500' : 'hover:border-flamingo-400 hover:text-zinc-500 border-transparent'}"
          >
          ${item.name}
        </a>
      `).join('')}
  </ul>
`;
if ($bac26ecb701a9cac$var$$courseSubMenu) $bac26ecb701a9cac$var$$courseSubMenu.innerHTML = $bac26ecb701a9cac$var$courseSubMenuHtml;


//# sourceMappingURL=competitions-2026.3a1291e6.js.map
